import React from "react";
import styled from "styled-components";

import LineSeedKrRg from "../../../../atoms/text/lineSeedKr/lineSeedKrRg";

const LSRgBody01 = (props) => {
  return <LSRgBody01Wrapper {...props} />;
};

export default LSRgBody01;

const LSRgBody01Wrapper = styled(LineSeedKrRg)`
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: -0.3px;

  color: #222222;
`;
